import { ThreeSectionSliderBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpThreeSectionSliderBlock } from './AmpThreeSectionSliderBlock';
import { ThreeSectionSliderBlock } from './ThreeSectionSliderBlock';

export const ThreeSectionSliderBlockMapping: BlockMapping<ThreeSectionSliderBlockData> =
  {
    invariant: [
      {
        prop: 'headline',
        msg: 'Heading required for Three Section Slider',
      },
      {
        prop: 'sections',
        msg: 'Sections required for Three Section Slider',
      },
    ],
    width: 'INSET',
    Component: ThreeSectionSliderBlock,
    AmpComponent: AmpThreeSectionSliderBlock,
  };
